import { Row, Col, Pagination, Input, Select, DatePicker, message } from "antd";
import { useState, useEffect,useCallback } from "react";
import { global_var } from "../../services/cs-lab-config";
import {getFromCache, setCache} from "../../services/cache-service";
import {
  loadClassRoomDetails,
  getDivisionDetails,
  loadUsersUnderRole,
  loadAcademicYear
} from "../../services/ide-apis";

const ProjectFilters = ({
  totalProjectsCount,
  filtersChanged,
  hideProjectTypeFilter,
  hideProjectStatusFilter,
  searchBoxPlaceHolder,
  hideClassFilter,
  hideDivisionFilter,
  userSelectBoxPlaceHolder,
  userRoleIds,
  hideUserFilter,
  hideAcademicYearFilter,
  hideDateFilter,
  hideProjectNameFilter,
  hidePaginationFilter,
  hidePendingEvaluationOption,
  hidePaginationTotalItems,
  showAcademicYearAfterSearch,
  savedFiltersKey,
}) => {
  const savedFilters = sessionStorage.getItem(savedFiltersKey || "evaluateProjectFilters");
  const [filters, setFilters] = useState(
    savedFilters
      ? JSON.parse(savedFilters)
      : {
          pageNo: global_var.EvaluateProjectsPageNo
            ? global_var.EvaluateProjectsPageNo
            : 1,
        }
  );
  const [classes, setClasses] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [academicYear, setAcademicYear] = useState([]);
  const [selectedAcademicYear, setSelectedAcademicYear] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const loadClassRooms = () => {
    const cachedData = getFromCache('classRoomsData');
    if (cachedData) {
      setClasses(cachedData)
    } else {
      let reqObj = {};
      reqObj.condition = { companyId: global_var.company_id, activeFlag: 1 };
      reqObj.projection = { className: 1, classCourseConfig: 1, fkClassRoomMasterId: 1 ,classAlias: 1};
      if (global_var.academicYearId) {
        reqObj.condition['academicYear'] = global_var.academicYearId
      }
      if (global_var.role_id === global_var.TEACHER_ROLE_ID && global_var.needClass) {
        reqObj.restrictClasses = true;
      }
      reqObj.rmId = global_var.roleMappingId;

      loadClassRoomDetails(reqObj)
        .then((response) => {
          let classes = JSON.parse(response.data);
          classes.forEach((class_) => {
            class_['_id'] = (class_['_id']['$oid'] ? class_['_id']['$oid'] : class_['_id']);
          });
          setClasses(classes); // Update the state with class data
          setCache('classRoomsData', classes);
        });
      }
  };

  const loadDivisions = (selectedClass) => {
    let divisionCondition = {
      companyId: global_var.company_id,
      classroomId: selectedClass,
      activeFlag: 1,
      rmId: global_var.roleMappingId
    };
    if (global_var.academicYearId) {
      divisionCondition['academicYear'] = global_var.academicYearId
    }
    let divisions = [];
    getDivisionDetails(divisionCondition)
      .then((response) => {
        if (response.data.statusCode === 200) {
          divisions = response.data.divisions;
          setDivisions(divisions);
        } else {
          message.error(response.data.message);
        }

      });
  };

  const fnLoadAcademicYears = useCallback(() => {
    const cachedData = getFromCache('academicYearData');
    if (cachedData) {
      setAcademicYear(cachedData);
      // Set current academic year as default if exists and no saved filter
      if (global_var.academicYearId && !selectedAcademicYear && !filters.fkAcademicYearId) {
        setSelectedAcademicYear(global_var.academicYearId);
        setFilters(prevFilters => ({
          ...prevFilters,
          fkAcademicYearId: global_var.academicYearId,
        }));
      }
    } else {
      let academicYears = [];
      loadAcademicYear(global_var.company_id, {type: "all" } )
        .then((response) => {
          if (response.status === 200) {
            academicYears = response.data.academicYear;
            setAcademicYear(academicYears);
            setCache('academicYearData', academicYears);
            if (global_var.academicYearId && !selectedAcademicYear && !filters.fkAcademicYearId) {
              setSelectedAcademicYear(global_var.academicYearId);
              setFilters(prevFilters => ({
                ...prevFilters,
                fkAcademicYearId: global_var.academicYearId,
              }));
            }
          } else {
            message.error(response.data.message);
          }

        });
    }
    
  }, [selectedAcademicYear, filters.fkAcademicYearId]);

  const loadUsersUnderRoleFn = useCallback((searchTerm) => {
    let userObj = {
      roleIds: [userRoleIds],
    }

    if (searchTerm) {
      userObj['searchText'] = searchTerm;
    }
    if (global_var.parent_company_id) {
      userObj['childCompanyId'] = global_var.company_id;
      userObj['companyId'] = global_var.parent_company_id;
    } else {
      userObj['companyId'] = global_var.company_id;
      userObj['skipAccessCompanies'] = true;

    }
    loadUsersUnderRole(userObj)
      .then((response) => {
        if (response.data.statusCode === 200 && response.data.users.length > 0) {
          setUsers(response.data.users);
        } else {
          setUsers([]);
        }

      });
  }, [setUsers, userRoleIds]);


  useEffect(() => {
    loadClassRooms();
  }, []);

  useEffect(() => {
    if (filters.fkAcademicYearId && !selectedAcademicYear) {
      setSelectedAcademicYear(filters.fkAcademicYearId);
    }
    if (filters.fkUserLoginId && !selectedUser) {
      setSelectedUser(filters.fkUserLoginId);
    }
    if (filters.fkDivisionId && !selectedDivision) {
      setSelectedDivision(filters.fkDivisionId);
    }
    if (filters.fkClassId && classes.length > 0) {
      loadDivisions(filters.fkClassId);
    }
  }, [
      classes,
      filters.fkAcademicYearId,
      filters.fkUserLoginId,
      filters.fkDivisionId,
      filters.fkClassId,
      selectedAcademicYear,
      selectedDivision,
      selectedUser
      
  ]);

  useEffect(() => {
    fnLoadAcademicYears();
  }, [fnLoadAcademicYears]);

  useEffect(() => {
    if(hideUserFilter){
      loadUsersUnderRoleFn();
    }
    
  }, [hideUserFilter,loadUsersUnderRoleFn]);

  useEffect(() => {
    filtersChanged(filters);
  }, [filters, filtersChanged]);

  return (
    <>
    <div className="mobile-card-scrollbar">
      <Row className="mb-2 mobile-card-scrollbar-row ">
        {!hideProjectNameFilter && (
          <Col xs={8} sm={8} md={6} lg={6} xl={6} className="mb-2">
            <Input.Search
            bordered={false}    
              placeholder={
                searchBoxPlaceHolder
                  ? searchBoxPlaceHolder
                  : global_var.role_id === global_var.STUDENT_ROLE_ID
                    ? "Search Project name"
                    : "Search Project name or Student name here..."
              }
              onSearch={(searchKey) => {
                setFilters({
                  ...filters,
                  projectName: searchKey,
                  studentName: searchKey,
                  pageNo: 1,
                });
              }}
              style={{ width: "95%", border:'1px solid #D7BEF7', borderRadius:'6px',backgroundColor:'#FFFFFF' }}
            />
          </Col>
        )}

        {!hideAcademicYearFilter && showAcademicYearAfterSearch && (
          <Col xs={8} sm={8} md={4} lg={4} xl={4} className="mb-2">
            <Select
              bordered={false}   
              allowClear
              style={{ minWidth: "95%", border:'1px solid #D7BEF7', borderRadius:'6px',backgroundColor:'#FFFFFF' }}
              placeholder={"Filter by academic year"}
              value={selectedAcademicYear}
              onChange={(selectedAcademicYearId) => {
                setSelectedAcademicYear(selectedAcademicYearId);
                setFilters({
                  ...filters,
                  pageNo: 1,
                  fkAcademicYearId: selectedAcademicYearId,
                });
              }}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={academicYear.map((academicYear_) => ({
                label: academicYear_.academicYearName,
                value: academicYear_._id,
                children: academicYear_.academicYearName,
              }))}
            />
          </Col>
        )}

        {!hideProjectTypeFilter && (
          <Col xs={8} sm={8} md={5} lg={4} xl={4}>
            <Select
              bordered={false}    
              style={{ minWidth: "95%",border:'1px solid #D7BEF7', borderRadius:'6px',backgroundColor:'#FFFFFF' }}
              value={filters.projectLanguage}
              onChange={(projectStack) => {
                setFilters({
                  ...filters,
                  pageNo: 1,
                  projectLanguage: projectStack,
                });
              }}
              placeholder="Filter by Project type"
              allowClear={true}
              options={[
                {
                  label: "Programming Languages",
                  options: [
                    { label: "Python", value: "python" },
                    { label: "Html", value: "html_css" },
                  ],
                },
                {
                  label: "Scratch",
                  options: [
                    { label: "Scratch", value: "vc3" },
                    { label: "Scratch Jr", value: "scratchjr" },
                  ],
                },
                {
                  label: "Database",
                  options: [{ label: "SQL", value: "sql2" }],
                },
                {
                  label: "Robotics",
                  options: [
                    { label: "Arduino", value: "arduino" },
                  ],
                },
                {
                  label: "Google Apps",
                  options: [
                    { label: "Google Docs", value: "gdocs" },
                    { label: "Google Sheets", value: "gsheets" },
                    { label: "Google Slides", value: "gslides" },
                  ],
                },
              ]}
            />
          </Col>
        )}

        {!hideProjectStatusFilter && (
          <Col xs={8} sm={8} md={4} lg={4} xl={4}>
            <Select
              bordered={false}             
              allowClear={true}
              style={{
                minWidth: "95%",
                border:'1px solid #D7BEF7', borderRadius:'6px',backgroundColor:'#FFFFFF'
              }}
              placeholder="Filter by status"
              value={filters.evaluationStatus}
              onChange={(selectedStatus) => {
                setFilters({
                  ...filters,
                  pageNo: 1,
                  evaluationStatus: selectedStatus,
                });
              }}
              options={[
                {
                  label: "Evaluated",
                  value: "Evaluated",
                },
                {
                  label: "Ask for resubmission",
                  value: "Ask for resubmission",
                },
                {
                  label: "Pending evaluation",
                  value: "submittedForEvaluation",
                },
                ...(!hidePendingEvaluationOption ? [] : [{
                  label: "Pending submission",
                  value: "Pending submission",
                }])
              ]}
            />
          </Col>
        )}
        {!hideDateFilter && (
          <Col xs={8} sm={8} md={4} lg={4} xl={4} className="mx-1">
            <DatePicker.RangePicker
              style={{
                minWidth: "95%", border:'1px solid #D7BEF7', borderRadius:'6px',backgroundColor:'#FFFFFF',height:'33px' 
              }}
              onChange={(e, dateArray) => {
                setFilters({
                  ...filters,
                  pageNo: 1,
                  submissionFromDate: dateArray[0],
                  submissionToDate: dateArray[1],
                });
              }}
            />
          </Col>
        )}
        {hideUserFilter && (
          <Col xs={6} sm={6} md={4} lg={4} xl={4} className="mx-1">
            <Select
              bordered={false}
              allowClear
              showSearch
              virtual={false} 
              style={{ minWidth: "95%", border:'1px solid #D7BEF7', borderRadius:'6px',backgroundColor:'#FFFFFF' }}
              placeholder={userSelectBoxPlaceHolder || "Search Project by trainer"}
              value={selectedUser}
              onChange={(selectedUserId) => {
                setSelectedUser(selectedUserId);
                setFilters({
                  ...filters,
                  pageNo: 1,
                  fkUserLoginId: selectedUserId,
                });
              }}
              onSearch={(searchTerm) => {
                loadUsersUnderRoleFn(searchTerm);
              }}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={users.map((user_) => ({
                label: user_.firstName || user_.Name || user_.userName,
                value: user_.fkUserLoginId,
                children: user_.firstName,
              }))}
            />

          </Col>
        )}
        {!hideAcademicYearFilter && !showAcademicYearAfterSearch && (
          <Col xs={6} sm={6} md={4} lg={4} xl={4} className="mx-1">
            <Select
              bordered={false}   
              allowClear
              style={{ minWidth: "95%", border:'1px solid #D7BEF7', borderRadius:'6px',backgroundColor:'#FFFFFF' }}
              placeholder={"Filter by academic year"}
              value={selectedAcademicYear}
              onChange={(selectedAcademicYearId) => {
                setSelectedAcademicYear(selectedAcademicYearId);
                setFilters({
                  ...filters,
                  pageNo: 1,
                  fkAcademicYearId: selectedAcademicYearId,
                });
              }}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={academicYear.map((academicYear_) => ({
                label: academicYear_.academicYearName,
                value: academicYear_._id,
                children: academicYear_.academicYearName,
              }))}
            />

          </Col>
        )}
        {!hideClassFilter && (
          <Col span={4}>
            <Select
              bordered={false}  
              allowClear={true}
              style={{
                minWidth: "95%", border:'1px solid #D7BEF7', borderRadius:'6px',backgroundColor:'#FFFFFF'
              }}
              placeholder="Filter by class"
              value={filters.fkClassId}
              onChange={(selectedClass) => {
                setFilters({
                  ...filters,
                  pageNo: 1,
                  fkClassId: selectedClass,
                  fkDivisionId: null,  // Set a fkDivisionId null to clear old divion id
                });
                if (selectedClass) {
                  loadDivisions(selectedClass);
                  setSelectedDivision(null);
                } else {
                  setDivisions([]);
                  setSelectedDivision(null);
                }
              }}
              options={classes.map((class_) => ({
                label: class_.classAlias,
                value: class_._id,
              }))}
            />
          </Col>
        )}
        {!hideDivisionFilter && (
          <Col span={4}>
            <Select
              bordered={false}  
              allowClear={true}
              style={{
                minWidth: "95%", border:'1px solid #D7BEF7', borderRadius:'6px',backgroundColor:'#FFFFFF'
              }}
              placeholder="Filter by division"
              value={selectedDivision} // Set the selected division 
              onChange={(selectedDivisions) => {
                setSelectedDivision(selectedDivisions);
                setFilters({
                  ...filters,
                  pageNo: 1,
                  fkDivisionId: selectedDivisions,
                });
              }}
              options={divisions.map((division_) => ({
                label: division_.divisionName,
                value: division_._id,
              }))}
            />
          </Col>
        )}
      </Row>
      {!hidePaginationFilter && (
        <Row className="mb-2 text-end">
          <Col span={24}>
            <div style={{ display: 'inline-block', border: '1px solid #FFECD2',borderRadius:'5px',padding:'1px'}}>
              <Pagination className="cs-pagination"
                defaultPageSize={12}
                showSizeChanger={false}
                total={totalProjectsCount}
                showTotal={hidePaginationTotalItems ? 
                  (totalProjectsCount, range) => `${range[0]}-${range[1]} of ${totalProjectsCount} Items` : null}
                current={filters.pageNo}
                onChange={(pageNo) => {
                  setFilters({
                    ...filters,
                    pageNo: global_var.EvaluateProjectsPageNo ? global_var.EvaluateProjectsPageNo : pageNo,
                  });
                }}
              />
            </div>
          </Col>
        </Row>
      )}
      </div>
    </>
  );
};

export default ProjectFilters;
